import { Map as ImmutableMap } from 'immutable';
import * as sessionStorageEx from 'utils/sessionStorageEx';

import { mkEntitlement } from './entitlementsTypes';

export const loadEntitlements = () => {
  const entitlementsStore = sessionStorageEx.getEntitlements();
  if (entitlementsStore) {
    entitlementsStore.resourcesById = ImmutableMap(entitlementsStore.resourcesById).map((entitlement) => mkEntitlement(entitlement));
  }
  return entitlementsStore;
};

export const saveEntitlements = (entitlementsStore) => sessionStorageEx.setEntitlements(entitlementsStore);

export const clearEntitlements = () => sessionStorageEx.removeEntitlemets();
